import React from "react";
import { withTheme } from "styled-components";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Headings";
import { Para } from "@irati/ui/src/Labels";
import { Select } from "@irati/ui/src/FormItem";
import Form from "@irati/ui/src/Form";
import Flex from "@irati/ui/src/Flex";
import SagaStep from "./SagaStep";
var BirthdayBoxSelection = function (_a) {
    var value = _a.value, options = _a.options, onChange = _a.onChange, formatMessage = _a.formatMessage, theme = _a.theme;
    return (React.createElement(Flex, { direction: "column" },
        React.createElement(SagaStep, null),
        React.createElement(H2, { small: true },
            React.createElement(FormattedMessage, { id: "perks.components.productForms.birthdayBoxSelection.title" })),
        React.createElement(Para, { margin: "0px 0px " + theme.spacing.two + " 0px" },
            React.createElement(FormattedMessage, { id: "perks.components.productForms.birthdayBoxSelection.text" })),
        React.createElement(Form, null,
            React.createElement(Select, { label: formatMessage({ id: "perks.components.productForms.birthdayBoxSelection.label" }), placeholder: formatMessage({ id: "perks.components.productForms.birthdayBoxSelection.placeholder" }), value: value, options: options, onChange: onChange }))));
};
export default injectIntl(withTheme(BirthdayBoxSelection));
